import request from '@/utils/request'
// 新的创建店铺接口
export function createShop(data) {
  return request({
    url: '/shop/createShop',
    method: 'post',
    data: data
  })
}
// 店铺列表接口
export function listShop(params) {
  return request({
    url: '/shop/listShop',
    method: 'get',
    params
  })
}
// 店铺列表接口
export function shopIdThreeCategory(params) {
  return request({
    url: '/shop/listShopThreeCategory',
    method: 'get',
    params
  })
}
// 审核列表
export function getAllAuthList(params) {
  return request({
    url: '/pendingAudit/getAllList',
    method: 'get',
    params
  })
}
// 
export function selectShop(id) {
  return request({
    url: '/admin/selectShopId/' + id,
    method: 'get',
  })
}
// 添加热门标签接口
export function createShopLabel(data) {
  return request({
    url: '/shop/createShopLabel',
    method: 'post',
    data
  })
}
// 热门标签接口
export function listShopLabel(params) {
  return request({
    url: '/shop/listShopLabel',
    method: 'get',
    params
  })
}
// 热门标签接口 - 详情  
export function getShopLabelInfo(id) {
  return request({
    url: '/shop/getShopLabelInfo/' + id,
    method: 'get',
  })
}
// 热门标签接口 - 删除 
export function deleteShopLabel(id) {
  return request({
    url: '/shop/deleteShopLabel/' + id,
    method: 'post',
  })
}
// 店铺详情接口
export function shopInfo(id) {
  return request({
    url: '/shop/getShopInfo/' + id,
    method: 'get',
  })
}
// 根据id获取 商品分类和品牌名称 接口
export function getShopCategoryInfo(params) {
  return request({
    url: '/shop/listShopCategory/',
    method: 'get',
    params
  })
}
// 根据id获取 编辑发货地址信息 接口
export function getShopAddressInfo(id) {
  return request({
    url: '/shop/getShopAddressInfo/' + id,
    method: 'get',
  })
}
// 编辑发货地址接口
export function updateShopAddress(data) {
  return request({
    url: '/shop/updateShopAddress/',
    method: 'post',
    data
  })
}
// 编辑店铺接口
export function updateShop(data) {
  return request({
    url: '/shop/updateShop',
    method: 'post',
    data
  })
}
// 发货地址接口
export function listShopAddress(params) {
  return request({
    url: '/shop/listShopAddress/',
    method: 'get',
    params
  })
}
// 创建地址接口
export function creatAddress(data) {
  return request({
    url: '/shop/createShopAddress/',
    method: 'post',
    data
  })
}
// 物流公司列表接口
export function logisticsList() {
  return request({
    url: '/util/getLogisticsList/',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/shop.js